module.exports = __webpack_public_path__ + "img/ico_codigo-de-barras.1f114ceb.svg";